import React, { Component, Fragment } from 'react';
import TimeSingle from './single';
import CheckBox from '../checkbox';

class TimeRange extends Component {
    render() {
        const {
            onStart,
            onStop,
            valueType,
            onStartSelectTime,
            onStopSelectTime,
            id,
            onCheckTime,
            checked
        } = this.props;
        return (
            <div className='timepicker-container flex-center'>
                  <CheckBox id={`${id}_checkbox`}
                    handleOnClick={onCheckTime}
                    checked={checked}/>
                <TimeSingle start={0} stop={23} selectedTime={onStart} valueType={valueType} handleOnChange={onStartSelectTime} isDisabled={!checked}/>
                ~
                <TimeSingle start={1} stop={24} selectedTime={onStop} valueType={valueType} handleOnChange={onStopSelectTime} isDisabled={!checked}/>
            </div>
        );
    }
}

export default TimeRange;


// WEBPACK FOOTER //
// ./src/components/timelist/rangeChk.js